/** Dados legais da empresa, os mesmos do comprovante do 1.0 (e do cadastro oficial). */
export const EMPRESA = {
  razao: 'Drogaria do Atacado LTDA',
  fantasia: 'Rede Inova',
  cnpj: '03.566.388/0001-80',
  cidade: 'Muriaé',
} as const;

/** "Muriaé, 24 de setembro de 2026" — a data do recibo. */
export function dataDoRecibo(d = new Date()): string {
  return `${EMPRESA.cidade}, ${d.toLocaleDateString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })}`;
}
